import { AnswerTypeEnum } from '../../constants/enums';

export function getStrategyFormatData(type, data) {
  if (!data) {
    return []; // Devuelve un array vacío si data es null o undefined
  }
  switch (type) {
    case AnswerTypeEnum.CHECK:
      return data?.map((test) => ({
        text: test.question,
        options: test?.answers?.map((option) => ({
          files: [],
          formula: '',
          text: option.text,
          correct: option.checked,
        })),
      }));
    case AnswerTypeEnum.WRITE:
      if (data.some((test) => test.isTyping)) {
        return data?.map((test) => ({
          text: test.question,
          writeResponse: test.answer,
          isTyping: test.isTyping,
        }));
      }
      return data?.map((test) => ({
        text: test.question,
        writeResponse: test.answer,
      }));

    case AnswerTypeEnum.TEXT:
      return data?.map((test) => ({
        text: test.question,
        maxChar: test.maxChar,
      }));
    case AnswerTypeEnum.TEXT_AI:
      return data?.map((test) => ({
        text: test.question,
        maxChar: test.maxChar,
        concepts: test.concepts,
        totalTime: test.totalTime,
      }));
    case AnswerTypeEnum.FILE:
      return data?.map((test) => ({
        text: test.question,
        fileTypes: test.types,
      }));
    case AnswerTypeEnum.CODE_AI:
      return data?.map((test) => ({
        text: test.question,
        existingCode: test.preCode,
      }));
    default:
      return null;
  }
}
